import differenceInYears from "date-fns/differenceInYears";
import { CellValue } from "generated/graphql";
import { stripNull } from "./coll";
import { parseDate } from "Backend";

export function ageAtDateFromCellValue(birth: Date, cv: CellValue | undefined): number | undefined {
  const dateValue = stripNull(cv?.dateValue);
  const date = parseDate(dateValue);
  if (date === undefined) return undefined;

  return differenceInYears(date, birth);
}
